"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Day = exports.ReportFrequency = exports.ReportType = exports.GroupAlertChannel = exports.GroupAlertType = exports.GroupEquipmentStatus = exports.AvailabilityStatus = exports.WeekDays = void 0;
var WeekDays;
(function (WeekDays) {
    WeekDays["Monday"] = "monday";
    WeekDays["Tuesday"] = "tuesday";
    WeekDays["Wednesday"] = "wednesday";
    WeekDays["Thursday"] = "thursday";
    WeekDays["Friday"] = "friday";
    WeekDays["Saturday"] = "saturday";
    WeekDays["Sunday"] = "sunday";
})(WeekDays = exports.WeekDays || (exports.WeekDays = {}));
var AvailabilityStatus;
(function (AvailabilityStatus) {
    AvailabilityStatus["Available"] = "available";
    AvailabilityStatus["UnAvailable"] = "unavailable";
})(AvailabilityStatus = exports.AvailabilityStatus || (exports.AvailabilityStatus = {}));
var GroupEquipmentStatus;
(function (GroupEquipmentStatus) {
    GroupEquipmentStatus["Working"] = "working";
    GroupEquipmentStatus["Unassigned"] = "unassigned";
    GroupEquipmentStatus["Breakdown"] = "breakdown";
    GroupEquipmentStatus["Removed"] = "removed";
})(GroupEquipmentStatus = exports.GroupEquipmentStatus || (exports.GroupEquipmentStatus = {}));
// Alerts settings
var GroupAlertType;
(function (GroupAlertType) {
    GroupAlertType["Geofence"] = "geofence";
    GroupAlertType["Overspeeding"] = "overspeeding";
    GroupAlertType["HarshDriving"] = "harsh driving";
    GroupAlertType["Idling"] = "idling";
    GroupAlertType["FuelTheft"] = "fuel theft";
    GroupAlertType["EquipmentMaintenance"] = "equipment_maintenance";
    GroupAlertType["Timesheet"] = "timesheet";
    GroupAlertType["EngineTemperature"] = "engine_temperature";
    GroupAlertType["EngineRPM"] = "engine_rpm";
})(GroupAlertType = exports.GroupAlertType || (exports.GroupAlertType = {}));
var GroupAlertChannel;
(function (GroupAlertChannel) {
    GroupAlertChannel["Email"] = "email";
    GroupAlertChannel["Sms"] = "sms";
    GroupAlertChannel["PushNotification"] = "push_notification";
    GroupAlertChannel["Whatsapp"] = "whatsapp";
})(GroupAlertChannel = exports.GroupAlertChannel || (exports.GroupAlertChannel = {}));
var ReportType;
(function (ReportType) {
    ReportType["Emissions"] = "Emissions";
    ReportType["Ignition"] = "Ignition";
    ReportType["DriverAuthentication"] = "DriverAuthentication";
    ReportType["ComprehensiveGeofence"] = "ComprehensiveGeofence";
    ReportType["ComprehensiveIgnition"] = "ComprehensiveIgnition";
    ReportType["Driver"] = "Driver";
    ReportType["WorktimeSummary"] = "WorktimeSummary";
    ReportType["WorktimeSummaryCan"] = "WorktimeSummaryCan";
    ReportType["FuelSummary"] = "FuelSummary";
    ReportType["Timesheet"] = "Timesheet";
    ReportType["Trip"] = "Trip";
    ReportType["Violation"] = "Violation";
    ReportType["Pepsi"] = "Pepsi";
    ReportType["Geofence"] = "Geofence";
    ReportType["GeofenceTrip"] = "GeofenceTrip";
    ReportType["ComprehensiveGeofenceTrip"] = "ComprehensiveGeofenceTrip";
    ReportType["FuelEvent"] = "FuelEvent";
    ReportType["EquipmentAllocation"] = "EquipmentAllocation";
    ReportType["PreventativeMaintenance"] = "PreventativeMaintenance";
    ReportType["Requests"] = "Requests";
    ReportType["Elevation"] = "Elevation";
    ReportType["MewpService"] = "MewpService";
    ReportType["ComprehensiveMewpService"] = "ComprehensiveMewpService";
    ReportType["MewpReport"] = "MewpReport";
    ReportType["Unresponsive"] = "Unresponsive";
    ReportType["DailyFuel"] = "DailyFuel";
    ReportType["Odometer"] = "Odometer";
    ReportType["Dispenser"] = "Dispenser";
    ReportType["TruckEfficiency"] = "TruckEfficiency";
    ReportType["SkidEfficiency"] = "SkidEfficiency";
    ReportType["PRMS"] = "PRMS";
    ReportType["Sajco"] = "Sajco";
    ReportType["Productivity"] = "Productivity";
    ReportType["AssetUtilizationReport"] = "AssetUtilizationReport";
    ReportType["AssetUnderUtilizationReport"] = "AssetUnderUtilizationReport";
    ReportType["DeviceInstallationHistoryReport"] = "DeviceInstallationHistory";
    ReportType["NotUsedAssetsReport"] = "NotUsedAssetsReport";
    ReportType["DistanceDrivenVehiclesReport"] = "DistanceDrivenVehiclesReport";
    ReportType["AssetListReport"] = "AssetListReport";
    ReportType["TachoReport"] = "TachoReport";
    ReportType["DistanceKMUpdateReport"] = "DistanceKMUpdateReport";
})(ReportType = exports.ReportType || (exports.ReportType = {}));
var ReportFrequency;
(function (ReportFrequency) {
    ReportFrequency["Daily"] = "daily";
    ReportFrequency["Weekly"] = "weekly";
    ReportFrequency["Monthly"] = "monthly";
})(ReportFrequency = exports.ReportFrequency || (exports.ReportFrequency = {}));
var Day;
(function (Day) {
    Day["SUN"] = "SUN";
    Day["MON"] = "MON";
    Day["TUE"] = "TUE";
    Day["WED"] = "WED";
    Day["THU"] = "THU";
    Day["FRI"] = "FRI";
    Day["SAT"] = "SAT";
})(Day = exports.Day || (exports.Day = {}));
//# sourceMappingURL=project.js.map